// ============================================================================
// STAKEHOLDERS SERVICE
// API service for project-scoped stakeholder tracking
// ============================================================================

import { api } from './api';
import { Stakeholder, StakeholderGovernanceLevel } from '../types';

export interface CreateStakeholderInput {
  name: string;
  role: string;
  governanceLevel: StakeholderGovernanceLevel;
  areaOfInterest?: string;
  signOffOrder?: number;
  notes?: string;
}

export type UpdateStakeholderInput = Partial<CreateStakeholderInput>;

export async function getStakeholders(
  projectId: string
): Promise<{ success: boolean; count: number; stakeholders: Stakeholder[] }> {
  const response = await api.get(`/api/projects/${projectId}/stakeholders`);
  return response.data;
}

export async function createStakeholder(
  projectId: string,
  input: CreateStakeholderInput
): Promise<{ success: boolean; stakeholder: Stakeholder }> {
  const response = await api.post(`/api/projects/${projectId}/stakeholders`, input);
  return response.data;
}

export async function updateStakeholder(
  projectId: string,
  stakeholderId: string,
  input: UpdateStakeholderInput
): Promise<{ success: boolean; stakeholder: Stakeholder }> {
  const response = await api.patch(`/api/projects/${projectId}/stakeholders/${stakeholderId}`, input);
  return response.data;
}

export async function deleteStakeholder(
  projectId: string,
  stakeholderId: string
): Promise<{ success: boolean }> {
  const response = await api.delete(`/api/projects/${projectId}/stakeholders/${stakeholderId}`);
  return response.data;
}
